import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authUrl } from '../utils/authReturn';

// Gates a route by the page's access level (public / member / private).
// - access granted            -> render the page
// - not signed in             -> send to sign in
// - signed in, no permission  -> Access Denied
function ProtectedRoute({ pagePath, children }) {
  const { user, loading, hasAccess } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh', color: '#6b7280' }}>
        Loading...
      </div>
    );
  }

  if (hasAccess(pagePath)) {
    return children;
  }

  if (!user) {
    // Come back to this page once signed in.
    return <Navigate to={authUrl('/signin', location)} replace />;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '50vh', color: '#6b7280' }}>
      <h2 style={{ color: '#374151' }}>Access Denied</h2>
      <p>You don't have permission to view this page.</p>
      <a href="/" style={{ color: '#2563eb' }}>Go to Home</a>
    </div>
  );
}

export default ProtectedRoute;
